import { isRef } from '@nuxtjs/composition-api';
import { CustomContentPage } from '~/models/abstracts/CustomContentPage';

export function getContentBlock(page, key) {
  let customContentPage;

  if (isRef(page)) {
    customContentPage = new CustomContentPage(page.value);
  } else if (page instanceof CustomContentPage) {
    customContentPage = page;
  } else {
    customContentPage = new CustomContentPage(page);
  }

  return customContentPage.getContentBlock(key);
}
